import { createStore } from 'owa-satcheljs';
import { mutatorAction } from 'satcheljs';

export interface ProactiveReadingPaneStore {
    isTriggerConditionMet: boolean;
}

export const getStore: () => ProactiveReadingPaneStore = createStore(
    'ProactiveReadingPaneSuaStore',
    { isTriggerConditionMet: false }
);

export const setTriggerConditionMetMutator: (value: boolean) => void = mutatorAction(
    'setTriggerConditionMet',
    (value: boolean): void => {
        getStore().isTriggerConditionMet = value;
    }
);
